import React, { useEffect, useRef, useState } from 'react';

const KrpanoExample = ({ selectedInfo }) => {
  const containerRef = useRef(null);
  const [krpanoLoaded, setKrpanoLoaded] = useState(false);
  const [휴게소명, set휴게소명] = useState("안성(부산)" || selectedInfo?.휴게소명 );

useEffect(() => {
  if (selectedInfo?.휴게소명) {
    set휴게소명(selectedInfo.휴게소명);
  }
}, [selectedInfo]);

  // 허용된 값인지 체크
  const allowed휴게소명 = ["망향(부산)", "건천(부산)", "경주(부산)", "안성(부산)", "옥산(부산)", "옥천(부산)", "천안호두(부산)", "칠곡(부산)", "추풍령(부산)", "통도사(부산)", "평사(부산)", "황간(부산)", "금강(부산)", "김천(부산)"];
  const isValid휴게소명 = allowed휴게소명.includes(휴게소명.trim());


  useEffect(() => {
    if (!isValid휴게소명) {
      setKrpanoLoaded(false);
      return;
    }
    if (window.embedpano) {
      try {
        console.log("✅ KRPano 실행:", `/krpano/${휴게소명}.xml`);
        window.embedpano({
          swf: null,
          xml: `/krpano/${휴게소명}.xml`,
          target: containerRef.current,
          html5: 'only',
          width: '100%',
          height: '100%',
        });
        setKrpanoLoaded(true);
      } catch (error) {
        console.error("❌ KRPano 로드 실패:", error);
        setKrpanoLoaded(false);
      }
    }
  
    return () => {
      if (containerRef.current) {
        console.log("🧹 Cleanup 실행: KRPano 제거");
        containerRef.current.innerHTML = '';
      }
    };
  }, [selectedInfo, 휴게소명]);
  

  return (
    <>
      {krpanoLoaded ? (
        <div ref={containerRef} style={{ width: '100%', height: '65vh', position: 'relative' }} />
      ) : (
        <div
          style={{
            width: '100%',
            height: '65vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f8f9fa',
            color: '#6c757d',
            fontSize: '1.2rem',
            border: '1px solid #dee2e6',
            position: 'relative',
          }}
        >
        업데이트 준비 중입니다.
        </div>
      )}
    </>
  );
};

export default KrpanoExample;
